export default __webpack_public_path__ + "static/Satoshi-Bold-a0e6d25529eab537426cc73a2199dd85.woff2";